import React from "react";

type CrossIconProps = {
  color?: string;
  height?: string;
  width?: string;
};

export default function CrossIcon(props: CrossIconProps) {
  const { color, height, width } = props;
  return (
    <svg
      width={width || "28px"}
      height={height || "28px"}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Designs"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Mobile---Notifications"
          transform="translate(-105.000000, -87.000000)"
          stroke={color || "#000000"}
          strokeWidth="1.5"
        >
          <g
            id="Organism-/-Header-/-Mobile-/-Secondary"
            transform="translate(106.000000, 88.000000)"
          >
            <line x1="0" y1="30" x2="30" y2="0" id="Path"></line>
            <line x1="30" y1="30" x2="0" y2="0" id="Path"></line>
          </g>
        </g>
      </g>
    </svg>
  );
}
